import Vue from "vue";
import VueRouter from "vue-router";
import GlobalGuards from "@/guards/Global";
import label from "@/lang/StaticLabels.js";

import TheMain from "@/containers/TheMain";
import TheContainer from "@/containers/TheContainer";
const Page404 = () => import("@/views/errors/Page404");
const Page403 = () => import("@/views/errors/Page403");
const Page500 = () => import("@/views/errors/Page500");
const PageUnderConstruction = () =>
  import("@/views/errors/PageUnderConstruction");

Vue.use(VueRouter);

const routes = [

  {
    path: "/",
    name: "MainContainer",
    component: TheMain,
    redirect: "/home",
    children: [
      {
        path: "home",
        name: "Home",
        meta: {
          label: label.page.dashboard,
          requiresAuth: true,
        },
        component: () => import("@/views/pages/Home"),
      },
      {
        path: "feedback",
        name: "Feedback",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: "/feedback",
        children: [
          {
            path: "list",
            name: "FeedbackList",
            component: () => import("@/views/pages/feedback"),
            meta: {
              label: "نظرسنجی",
              requiresAuth: true,
            },
          },
          {
            path: "details/:id",
            name: "FeedbackDetails",
            component: () => import("@/views/pages/feedback/Details"),
            meta: {
              label: "جزئیات نظرسنجی",
              requiresAuth: true,
            },
          },
          {
            path: "final",
            name: "FeedbackFinal",
            component: () => import("@/views/pages/feedback/Final"),
            meta: {
              label: "پایان نظرسنجی",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: "creditTransaction",
        name: "Credit",
        component: () => import("@/views/pages/credit"),
        meta: {
          label: "تبدیل امتیاز به اعتبار",
          requiresAuth: true,
        },
      },
      {
        path: "creditDetails",
        name: "CreditDetails",
        component: () => import("@/views/pages/credit/Detail"),
        meta: {
          label: "جزئیات اعتبار",
          requiresAuth: true,
        },
      },
      {
        path: "campain/:id",
        name: "CampainDetail",
        component: () => import("@/views/pages/campain"),
        meta: {
          label: "جزئیات کمپین",
          requiresAuth: true,
        },
      },
      {
        path: "shop/profile/:id",
        name: "ShopProfile",
        component: () => import("@/views/pages/shop"),
        meta: {
          label: "پروفایل فروشگاه",
          requiresAuth: true,
        },
      },
      {
        path: "score",
        name: "Score",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: "/score",
        children: [
          {
            path: "list",
            name: "ScoreList",
            component: () => import("@/views/pages/score/List"),
            meta: {
              label: "امتیازات",
              requiresAuth: true,
            },
          },
          {
            path: "detail/:id",
            name: "GiftDetails",
            component: () => import("@/views/pages/score/Detail"),
            meta: {
              label: label.page.giftDetails,
              requiresAuth: true,
            },
          },
        ],
      },

      {
        path: "transactions",
        name: "Transactions",
        component: () => import("@/views/pages/transaction"),
        meta: {
          label: "خریدها و تراکنش‌های من",
          requiresAuth: true,
        },
      },


    // Profile Container
      {
        path: "user",
        name: "User",
        component: TheContainer,
        redirect: "/profile",
        children: [
          {
            path: "profile",
            name: "Profile",
            component: () => import("@/views/auth/Profile"),
            meta: {
              label: "اطلاعات کاربری",
              requiresAuth: true,
            },
          },
          {
            path: "info",
            name: "UserInfo",
            component: () => import("@/views/pages/user/Info"),
            meta: {
              label: label.page.userInfo,
              requiresAuth: false,
            },
          },
          {
            path: "cards",
            name: "UserCards",
            component: () => import("@/views/pages/user/Card"),
            meta: {
              label: label.page.cards,
              requiresAuth: false,
            },
          },
          {
            path: "shopIntroduction",
            name: "ShopIntroduction",
            component: () => import("@/views/pages/user/ShopIntro"),
            meta: {
              label: label.menu.introStore,
              requiresAuth: false,
            },
          },
          {
            path: "support",
            name: "Support",
            component: () => import("@/views/pages/user/Support"),
            meta: {
              label: label.menu.support,
              requiresAuth: false,
            },
          },
          {
            path: "about-us",
            name: "AboutUs",
            component: () => import("@/views/pages/user/About-Us"),
            meta: {
              label: label.menu.aboutUs,
              requiresAuth: false,
            },
          },
          {
            path: "contact-us",
            name: "ContactUs",
            component: () => import("@/views/pages/user/Contact-Us"),
            meta: {
              label: label.menu.contactUs,
              requiresAuth: false,
            },
          },
          {
            path: "invite",
            name: "Invite",
            component: () => import("@/views/pages/user/Invite"),
            meta: {
              label: label.menu.inviteFriends,
              requiresAuth: false,
            },
          },


    // end of profile container
        ],
      },

  // end of main container
    ],
  },

  // other Pages - without container
  {
    path: "/login",
    name: "Login",
    meta: {
      label: label.page.login,
    },
    component: () => import("@/views/auth/Login"),
    beforeEnter(to, from, next) {
      GlobalGuards.login(to, from, next);
    },
  },


  {
    path: "/pages",
    redirect: "/pages/404",
    name: "Pages",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: [
      {
        path: "404",
        name: "Page404",
        component: Page404,
      },
      {
        path: "403",
        name: "Page403",
        component: Page403,
      },
      {
        path: "500",
        name: "Page500",
        component: Page500,
      },
      {
        path: "underConstruction",
        name: "PageUnderConstruction",
        component: PageUnderConstruction,
      },
    ],
  },

  {
    path: "*",
    component: Page404,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes,
});

router.beforeEach((to, from, next) => GlobalGuards.beforeEach(to, from, next));
router.afterEach((to, from) => GlobalGuards.afterEach(to, from));

export default router;
